const levelData = {
    "info": {
        "NumberOfLevels": 12
    },
    "data": [
        {
            "number": 1,
            "dices": 4,
            "cols": 2,
            "time": 3,
            "gen": 4
        },
        {
            "number": 2,
            "dices": 6,
            "cols": 3,
            "time": 5,
            "gen": 4
        },
        {
            "number": 3,
            "dices": 6,
            "cols": 3,
            "time": 3,
            "gen": 6
        },
        {
            "number": 4,
            "dices": 9,
            "cols": 3,
            "time": 8,
            "gen": 5
        },
        {
            "number": 5,
            "dices": 9,
            "cols": 3,
            "time": 6,
            "gen": 6
        },
        {
            "number": 6,
            "dices": 9,
            "cols": 3,
            "time": 5,
            "gen": 7
        },
        {
            "number": 7,
            "dices": 12,
            "cols": 4,
            "time": 15,
            "gen": 5
        },
        {
            "number": 8,
            "dices": 12,
            "cols": 4,
            "time": 12,
            "gen": 6
        },
        {
            "number": 9,
            "dices": 12,
            "cols": 4,
            "time": 10,
            "gen": 7
        },
        {
            "number": 10,
            "dices": 16,
            "cols": 4,
            "time": 17,
            "gen": 7
        },
        {
            "number": 11,
            "dices": 16,
            "cols": 4,
            "time": 15,
            "gen": 8
        },
        {
            "number": 12,
            "dices": 16,
            "cols": 4,
            "time": 12,
            "gen": 9
        },
    ]
}
export default levelData;